import React, { useState } from 'react'
import { MDBRow, MDBCol, MDBContainer } from "mdbreact";
import { Button, Card, Textarea, TimePicker } from 'react-rainbow-components';
import 'react-quill/dist/quill.snow.css';
import { RequestInitWithBody } from '../shared/RequestInit';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import ShowNotification from '../shared/Notification'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';


export interface UpdateEmissionProps {
    location: {
        state: {
            planning_Id: number,
            emissions_Id: number,
            emission: string,
            description: string,
            jour: string,
            heure_debut: string,
            heure_Fin: string,
            nom: string,
            active: 0 | 1,
            livecam: 0 | 1,
            planning_active: 0 | 1,
            emission_banniere: string
        }
    }

}

const UpdateUSerEmission: React.FC<UpdateEmissionProps> = (props: UpdateEmissionProps) => {
    console.log(props.location.state)
    /* state for the name and description of the emission */
    const [Emission, setEmission] = useState<string>(props.location.state.emission)
    const [BanniereIMG, setBanniereIMG] = useState<string>(props.location.state.emission_banniere)
    const [Desription, setDesription] = useState<string>(props.location.state.description)
    const [Emission_Id, setPEmission_Id] = useState<number>(props.location.state.emissions_Id)
    const [Jour, setJour] = useState<string>(props.location.state.jour)
    const [Heure_Debut, setHeure_Debut] = useState<string>(props.location.state.heure_debut)
    const [Heure_Fin, setHeure_Fin] = useState<string>(props.location.state.heure_Fin)
    const [Nom, setNom] = useState<string>(props.location.state.nom)
    /* state for each input field where we set the error message*/
    const [errorDesription, setErrorDesription] = useState<string>('')
    /* loading state for when a user submits an upadte for the emission */
    const [loading, setLoading] = useState<boolean>(false)
    const [UploadError, setUploadError] = useState<boolean>(false)
    const history = useHistory();

    const updateEmission = () => {
        if (Desription !== '') {
            setUploadError(false)
            const updateEmission = async () => {
                await fetch('https://admin.radioemotion.be/api/emission/updatedescription', RequestInitWithBody({ body: { Id: Emission_Id, description: Desription.replace(/\r?\n/g, "\\n").replace(/"/g, '\\"') }, type: 'PUT' }) as RequestInit)
                    .then(response => response.json())
                    .then(response => {
                        if (response.response === true) {
                            history.push({ pathname: '/emission/monplanning', state: { passed: true, message: `L'emission a été mise à jour ` } })
                        } else {
                            setUploadError(true)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            updateEmission();
        }
    }

    return (
        <>
            { UploadError ?
                <>
                    <ShowNotification
                        icon="times"
                        iconClassName="color-red"
                        bodyClassName="color-red background-color-red text-white"
                        autohide={5000}
                        title=""
                        message="Une erreur s'est produite"
                        text="maintenant"
                    />
                </> : null
            }
            <MDBContainer className="min-h-100vh ">
                <MDBRow className="mb-5 mt-2">
                    <Link to='/emission/monplanning'>
                        <Button
                            variant="neutral"
                            className='mt-2'
                        > <FontAwesomeIcon icon={faHome} className="py-1" size='2x' /></Button>
                    </Link>
                </MDBRow>
                <MDBRow>
                    <MDBCol md={"12"} xs={"12"} sm={"12"} className="mb-5">
                        <Card footer={<h1>
                    Banniere
                </h1>}>
                        
                            <img src={BanniereIMG} className="h-75 w-100" ></img>
                        </Card>
                    </MDBCol>
                    <form encType="multipart/form-data" className="w-100">
                        <MDBRow>
                            <MDBCol md={"12"} xs={"12"} sm={"12"} className="mb-5">
                                <Textarea
                                    id="emissionNome"
                                    label="Titre de l'emission "
                                    placeholder="Titre de l'emission"
                                    value={Emission}
                                    disabled
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={"12"} xs={"12"} sm={"12"} className="mb-5">
                                <Textarea
                                    id="actualiteCreateTitre"
                                    label="Description de l'emission"
                                    rows={2}
                                    placeholder="Description de l'emission"
                                    grow={true}
                                    onChange={e => { setDesription(e.target.value); { e.target.value === '' ? setErrorDesription("Le titre est obligatoire") : setErrorDesription('') } }}
                                    value={Desription}
                                    error={errorDesription}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <TimePicker
                                    readOnly
                                    value={Heure_Debut}
                                    label="Heure de début"
                                    hour24
                                />
                            </MDBCol>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <TimePicker
                                    readOnly
                                    value={Heure_Fin}
                                    label="Heure de fin"
                                    hour24
                                />
                            </MDBCol>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <Textarea
                                    id="emissionNome"
                                    label="Jour de l'emission"
                                    placeholder="Jour de l'emission"
                                    value={Jour}
                                    readOnly
                                    disabled

                                />
                            </MDBCol>
                            <MDBCol md={"3"} xs={"12"} sm={"12"}>
                                <Textarea
                                    id="emissionNome"
                                    label="Nom de l'animateur"
                                    placeholder="Nom de l'animateur"
                                    value={Nom}
                                    readOnly
                                    disabled
                                />
                            </MDBCol>
                            <MDBCol md={"3"}>

                            </MDBCol>
                        </MDBRow>

                    </form>
                </MDBRow>
                <MDBRow end>
                    <Button
                        isLoading={loading}
                        label='Mettre à jour'
                        onClick={() => updateEmission()}
                        variant="brand"
                        className='mt-2 mb-4 font-weight-bold'
                    />
                </MDBRow>
            </MDBContainer>
        </>
    )
}

export default UpdateUSerEmission
